export const baseFilters = {
  mode: 'mode',
  search: 'searchText',
  filterBySelected: 'filterBySelected',
  filterByMonitored: 'filterByMonitored', // feature flag protected
} as const;

const baseRangeFilters = {
  from: 'from',
  to: 'to',
} as const;

export const sitesAndLnsFilters = {
  ...baseFilters,
  ...baseRangeFilters,
  show: 'show',
  status: 'status',
  onlyAssociatedWithDma: 'onlyAssociatedWithDma',
  // additional (ui only) - excluded from api calls
  tab: 'tab',
} as const;
type SitesAndLnsFiltersType = (typeof sitesAndLnsFilters)[keyof typeof sitesAndLnsFilters];

export const newLeaksFilters = {
  ...baseFilters,
  show: 'show',
  type: 'type', // feature flag protected
} as const;
type NewLeaksFiltersType = (typeof newLeaksFilters)[keyof typeof newLeaksFilters];

export const maintenanceFilters = {
  ...baseFilters,
  maintenance: 'maintenance',
} as const;
type MaintenanceFiltersType = (typeof maintenanceFilters)[keyof typeof maintenanceFilters];

export const leakAnalysisFilters = {
  ...baseFilters,
  analysisPriority: 'analysisPriority',
  categorisation: 'categorisation',
} as const;
type LeakAnalysisFiltersType = (typeof leakAnalysisFilters)[keyof typeof leakAnalysisFilters];

export const deploymentFilters = {
  ...baseRangeFilters,
  search: 'search',
} as const;
type DeploymentFiltersType = (typeof deploymentFilters)[keyof typeof deploymentFilters];

export const correlationFilters = {
  ...baseRangeFilters,
  status: 'siteStatusFilter',
  site1: 'site1',
  site2: 'site2',
  multiCorrelationId: 'multiCorrelationId', // multi, pending
  correlationId: 'correlationId', // auto, manual
  actioned: 'actioned',
  gisLinear: 'gisLinear',
  confidence: 'confidence',
} as const;
type CorrelationFiltersType = (typeof correlationFilters)[keyof typeof correlationFilters];

export const surveysFilters = {
  ...baseRangeFilters,
  status: 'status',
  result: 'result',
} as const;
type SurveysFiltersType = (typeof surveysFilters)[keyof typeof surveysFilters];

export const audioAnalysisFilters = {
  search: 'search',
  type: 'type',
  predictedClass: 'predictedClass',
} as const;
type AudioAnalysisFiltersType = (typeof audioAnalysisFilters)[keyof typeof audioAnalysisFilters];

//

const FilterContext = [
  'all',
  'sitesAndLns',
  'newLeaks',
  'maintenance',
  'leakAnalysis',
  'deployment',
  'correlation',
  'surveys',
  'audioAnalysis',
] as const;
export type FilterContextType = (typeof FilterContext)[number];

type FilterType<Type extends FilterContextType> = Type extends 'all'
  ? SitesAndLnsFiltersType | NewLeaksFiltersType | MaintenanceFiltersType | LeakAnalysisFiltersType
  : Type extends 'sitesAndLns'
    ? SitesAndLnsFiltersType
    : Type extends 'newLeaks'
      ? NewLeaksFiltersType
      : Type extends 'maintenance'
        ? MaintenanceFiltersType
        : Type extends 'leakAnalysis'
          ? LeakAnalysisFiltersType
          : Type extends 'deployment'
            ? DeploymentFiltersType
            : Type extends 'correlation'
              ? CorrelationFiltersType
              : Type extends 'surveys'
                ? SurveysFiltersType
                : Type extends 'audioAnalysis'
                  ? AudioAnalysisFiltersType
                  : never;
export type FilterStateReturnType<Type extends FilterContextType> = Partial<Record<FilterType<Type>, string>>;

